import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { App as AntApp, ConfigProvider } from 'antd';
import RoutesList from './routes';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { ReAuthProvider } from './context/ReAuthContext';
import ReAuthModal from './components/ReAuthModal';
import ErrorBoundary from './components/ErrorBoundary';

/**
 * Inner App component that has access to Ant Design's App context
 * This is needed because NotificationProvider uses App.useApp() hooks
 */
function AppContent() {
  const { i18n } = useTranslation();

  // Sync HTML lang attribute with current language for proper hyphenation
  useEffect(() => {
    document.documentElement.lang = i18n.language || 'en';
  }, [i18n.language]);

  return (
    <NotificationProvider>
      <AuthProvider>
        <ReAuthProvider>
          <ErrorBoundary>
            <div className="App">
              <RoutesList />
              <ReAuthModal />
              <ToastContainer position="bottom-right" autoClose={5000} />
            </div>
          </ErrorBoundary>
        </ReAuthProvider>
      </AuthProvider>
    </NotificationProvider>
  );
}

/**
 * Main App component
 * Wraps with Router, Ant Design ConfigProvider, and AntApp for notifications
 */
function App() {
  return (
    <Router>
      <ConfigProvider
        theme={{
          token: {
            // Primary color - can be customized
            colorPrimary: '#1890ff',
          },
        }}
      >
        <AntApp>
          <AppContent />
        </AntApp>
      </ConfigProvider>
    </Router>
  );
}

export default App;
